import Vue from 'vue'

const mixin = {
  components: {
    InputDateRange: () =>
      import('@/components/MasterDataLandingpage/input-date-range.vue'),
    MasterDataInputList: () =>
      import('@/components/MasterDataLandingpage/master-data-input-list.vue'),
  },
}

Vue.mixin(mixin)

export { mixin }
